import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.collab.dashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-collab-dashboard',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.collab.dashboard/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysadminCollabDashboardComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public stats: any = { workspaces: 0, members: 0, activities: 0 };
    public workspaces: any[] = [];
    public activities: any[] = [];
    public loaded: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        const res = await wiz.call("summary", {});
        if (res.code === 200) {
            this.stats = res.data.stats || this.stats;
            this.workspaces = res.data.workspaces || [];
            this.activities = res.data.activities || [];
        }
        this.loaded = true;
        await this.service.render();
    }

    public goWorkspace(ws: any) {
        this.service.href(`/admin/collab/workspace/${ws.id}`);
    }

    public goCreate() {
        this.service.href(`/admin/collab/workspace`);
    }
}

export default PortalLpsysadminCollabDashboardComponent;